import React from 'react'
import FeaturesCarousel from './FeaturesCarousel';
import  smiley from "../assets/smiley-o-svgrepo-com.svg";
import cloud from "../assets/cloud-sun-svgrepo-com.svg";
import  keyb  from "../assets/keyboard-alt-1-svgrepo-com.svg";


function Features() {
  return (
    <div id='Services' className='features-container'>
      <h2>Services</h2>
      <ul className='services-list'>
        <li><img src={keyb} className='list-icon'/>{" "}<p>We offer end-to-end software development, covering planning to maintenance.</p></li>
        <li><img src={cloud} className='list-icon'/>{" "}<p>Our cloud-based solutions enhance business efficiency, security, and sustainability.</p></li>
        <li><img src={smiley} className='list-icon'/>{" "}<p>Stress-free product development for non-tech SaaS founders, turning their ideas into reality.</p></li>
      </ul>
      <div className='features-wrapper'>
    
          <FeaturesCarousel />
      </div>
    </div>
  )
}

export default Features